export default "__VITE_ASSET__DfKFNAxg__"